import { createRouter, createWebHistory } from 'vue-router'


import { UAParser } from 'ua-parser-js';
const parser = new UAParser();
const uaResult = parser.getResult();
  
// PC端组件
// import PCHome from './views/pc/home.vue'
// import PCRank from './views/pc/rank.vue'
// import PCSearch from './views/pc/search.vue'
// import PCRole from './views/pc/roleinfo.vue'


// 移动端组件
// import MobilHome from './views/mobile/home.vue'
// import MobilRank from './views/mobile/rank.vue'
// import MobilSearch from './views/mobile/search.vue'
// import MobilRole from './views/mobile/roleinfo.vue'

// const routeComponents = {
//     pc: {
//         Home: PCHome,
//         Rank: PCRank,
//         Search: PCSearch,
//         Role: PCRole,
//     },
//     mobile: {
//         Home: MobilHome,
//         Rank: MobilRank,
//         Search: MobilSearch,
//         Role: MobilRole,
//     }
// }


// const getComponent = (componentName) => {
//     // const isMobile = uaResult.device.type === 'mobile' ? true : false;
//     const deviceType = isMobile ? 'mobile' : 'pc'
//     console.log('getComponent', deviceType, componentName)
//     const component = routeComponents[deviceType][componentName]
//     console.log('getComponent component', component)
//     // const module = await notFoundLoader()
//     return component
// }

const isMobile = uaResult.device.type === 'mobile' ? true : false;
const deviceType = isMobile ? 'mobile' : 'pc'

const routes = [
    {
        path: '/home',
        name: 'home',
        component: () => import(`@/views/${deviceType}/home.vue`),
    },
    {
        path: '/rank',
        name: 'rank',
        component: () => import(`@/views/${deviceType}/rank.vue`)
    },
    {
        path: '/search',
        name: 'search',
        component: () => import(`@/views/${deviceType}/search.vue`)
    },
    {
        path: '/role',
        name: 'role',
        component: () => import(`@/views/${deviceType}/roleinfo.vue`)
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/home'  // 重定向到首页
    },
]

const base_url = import.meta.env.VITE_ENV == 'development' ? '/lc_f1/' : `/${import.meta.env.VITE_TEAM}/`
const router = createRouter({
    history: createWebHistory(base_url),
    routes
})

export default router